import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { useHydrateAtoms } from "jotai/utils";
import { queryClientAtom } from "jotai-tanstack-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { router } from "./routes";
import "./styles.css";

const queryClient = new QueryClient();

// Bind jotai-tanstack-query's queryClientAtom to the app's QueryClient.
// Without this, atomWithQuery/atomWithMutation use a default unbound client
// and `invalidateQueries` never reaches this tree's cache.
const HydrateQueryClientAtom: React.FC<React.PropsWithChildren> = ({ children }) => {
  useHydrateAtoms([[queryClientAtom, queryClient]]);
  return children;
};

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("index.html is missing #root");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <HydrateQueryClientAtom>
        <RouterProvider router={router} />
      </HydrateQueryClientAtom>
    </QueryClientProvider>
  </StrictMode>,
);
